<template>
  <div class='content' :class="visible ? 'content--visible' : ''">
      <h2>Our public transport perspective</h2>
      <p>
        <strong>Removing driving from the equation illuminates how different parts of the city are best served by public transport modes for the morning commute.</strong>
      </p>
      <p>
        Areas that include rail lines or act as feeder zones to the rail network are visible in the West, South and parts of Sydney’s North – where rail consistently outperforms bus travel. Sydney’s East is typically best served by bus, however this is expected to be impacted by the arrival of the light rail system.
      </p>
      <p>
        Select a single postcode to follow through the journey.
      </p>
      <multiselect 
        class="postcode__selector"
        :value="selectedPostcode" 
        :options="data" 
        track-by="postcode"
        label="label"
        @input="update_selected_postcode"
      ></multiselect>
  </div>
</template>

<script>
import tooltip_mixin from '@/assets/tooltip_mixin'

export default {
  props: {
    visible: {
        default: () => false
    }
  },
  mixins: [ tooltip_mixin ]
}
</script>

<style scoped>

.postcode__selector {
  width: 80%;
}

</style>